<template>
  <div class="data-list-container">
    <el-button-group class="menu-group">
      <el-button
        icon="el-icon-copy-document"
        title="复制"
        size="mini"
        round
        @click="copyDate()"
      ></el-button>
      <el-button
        round
        icon="el-icon-document-add"
        title="粘贴"
        size="mini"
        @click="pasteDate()"
      ></el-button>
    </el-button-group>
    <div
      class="data-item"
      v-for="(item, index) in customProps"
      :key="item.time"
    >
      <div class="data-label">{{ item.name }}</div>
      <div class="prop-list-content">
        <div class="info-content">
          <div class="enter-info">
            <el-input size="mini" v-model="item.value"></el-input>
          </div>
          <div class="edit-menu">
            <el-button
              icon="el-icon-link"
              circle
              size="mini"
              title="绑定数据"
              @click="bindData(index)"
            ></el-button>
            <el-button
              icon="el-icon-delete"
              circle
              size="mini"
              title="删除"
              @click="remove(index)"
            ></el-button>
            <el-button
              icon="el-icon-edit"
              circle
              size="mini"
              title="编辑"
              @click="edit(index)"
            ></el-button>
          </div>
        </div>
        <div class="bind-data-list" v-if="item.bindData">
          <div>
            已绑定数据
            <el-tooltip placement="top">
              <div slot="content">
                <div class="module-info">
                  选择属性：
                  <div class="name">{{ item.dataIds.key }} :</div>
                  <div class="value">{{ item.value }}</div>
                </div>
                <div>
                  绑定到属性：
                  {{ item.key }}
                </div>
                <div>
                  模块名称：
                  {{ item.bindData.controlName || item.bindData.name }}
                </div>
              </div>
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <el-button
            class="bind-btn"
            icon="el-icon-delete"
            circle
            size="mini"
            title="删除已绑定的属性"
            @click="removeBindData(index)"
          ></el-button>
        </div>
      </div>
    </div>

    <el-button size="mini" @click="addProp" type="primary">添加数据</el-button>

    <el-dialog
      title="添加属性"
      :visible.sync="dialogFormVisible"
      :modal="false"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model="form.name"
            autocomplete="off"
            size="mini"
            placeholder="绑定数据的别称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="属性名"
          :label-width="formLabelWidth"
          prop="propName"
        >
          <el-input
            v-model="form.propName"
            autocomplete="off"
            size="mini"
            placeholder="属性名对应组件的属性或自定义一个属性"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            v-model="form.description"
            autocomplete="off"
            size="mini"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型" :label-width="formLabelWidth">
          <el-select
            v-model="form.type"
            placeholder="请选择活动区域"
            size="mini"
          >
            <el-option
              :label="item.label"
              :value="item.type"
              v-for="item in propType"
              :key="item.type"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 数值型 -->
        <!-- <template v-if="form.type === dataType.number">
          <el-form-item label="最小值" :label-width="formLabelWidth">
            <el-input-number
              size="mini"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="最大值" :label-width="formLabelWidth">
            <el-input-number
              size="mini"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </template> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confrimAddProps">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定数据 -->

    <el-dialog
      title="绑定数据"
      :visible.sync="dialogDataVisible"
      :modal="false"
    >
      <bind-data-component
        @close="closeBindData"
        @confirm="confirmBindData"
        v-if="dialogDataVisible"
      ></bind-data-component>
    </el-dialog>
  </div>
</template>
<script>
import { dataType } from "../../types/sprite-types";
import BindDataComponent from "./bind-data.vue";
const dialogFormType = {
  add: 0,
  edit: 1,
};
export default {
  components: { BindDataComponent },
  data() {
    return {
      dataType, //数据类型
      dialogFormVisible: false, //添加属性显示
      dialogDataVisible: false, //绑定数据显示
      dialogFormType: dialogFormType.add,
      propType: [
        {
          label: "文本",
          type: dataType.text,
        },
        {
          label: "多行文本",
          type: dataType.textarea,
        },
        {
          label: "颜色",
          type: dataType.color,
        },
        {
          label: "数字",
          type: dataType.number,
        },
        {
          label: "下拉选择",
          type: dataType.downselect,
        },
        {
          label: "开关",
          type: dataType.swicth,
        },
        {
          label: "滑动条",
          type: dataType.slide,
        },
        {
          label: "Json",
          type: dataType.json,
        },
      ],
      form: {
        name: "",
        propName: "",
        type: "",
        description: "",
      },
      rules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        propName: [
          { required: true, message: "属性不能为空", trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      customProps: [], //用户自定义的属性列表
      current: -1,
      bindDataIndex: -1, //要绑定的属性的下标
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    console.log("添加数据初始化");
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },
  methods: {
    closeBindData() {
      this.dialogDataVisible = false;
    },
    // 确认绑定的数据
    confirmBindData(moduel) {
      if (!moduel) return;
      let { selectModule, selectProp } = moduel;
      this.dialogDataVisible = false;
      this.customProps[this.bindDataIndex].bindData = selectModule; //保存原始数据
      if (!this.customProps[this.bindDataIndex].dataIds) {
        this.customProps[this.bindDataIndex].dataIds = {};
      }

      // 配置相关绑定的数据
      this.customProps[this.bindDataIndex].id = this.customProps[
        this.bindDataIndex
      ].dataIds.dataId = selectModule.id; //用于更新指定模块的id
      this.customProps[this.bindDataIndex].dataIds.key = selectProp.key;
      this.customProps[this.bindDataIndex].dataIds.value = selectProp.value;
      this.customProps[this.bindDataIndex].value = selectProp.value;
      //   this.customProps[this.bindDataIndex].key = selectProp.key;
    },
    addProp() {
      this.dialogFormType = dialogFormType.add;
      this.dialogFormVisible = true;
    },
    // 初始化
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }
      if (!this.active) return;
      this.customProps = this.active.form || [];
    },
    // 绑定数据
    bindData(index) {
      this.dialogDataVisible = true;
      this.bindDataIndex = index;
    },
    saveConfig() {
      // 该对象用于配合active的自定义属性进行数据判断和处理
      try {
        this.active.form = this.customProps;
        // 只有在active下的属性才会监听数据更新，将要绑定的属性放到active下,并初始化值
        this.customProps.forEach((item) => {
          if (item.dataIds) {
            this.active[item.propName] = item.dataIds.value;
          }
          this.active[item.propName] = item.value;
        });

        this.topo.stageCanvas.initBindDatas();

        
      } catch (error) {
        console.log(error);
      }
    },
    // 删除绑定的属性
    remove(index) {
      delete this.active[this.customProps[index].propName];
      this.customProps.splice(index, 1);
    },
    removeBindData(index) {
      this.customProps[index].bindData = "";
    },
    // 编辑已绑定的数据
    edit(index) {
      this.dialogFormType = dialogFormType.edit;
      this.current = index;
      this.form.name = this.customProps[index].name;
      this.form.propName = this.customProps[index].propName;
      this.form.description = this.customProps[index].description;
      this.form.type = this.customProps[index].type;
      this.dialogFormVisible = true;
    },
    confrimAddProps() {
      if (
        !this.active ||
        (Reflect.has(this.active, this.form.propName) &&
          !confirm("是否覆盖原属性？"))
      ) {
        return;
      }

      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let propObj = {
            name: this.form.name,
            propName: this.form.propName,
            type: this.form.type,
            description: this.form.description,
            key: this.form.propName, //需要绑定的具体属性的key
            value: "",
            bindData: "", //用于绑定的真实数据，来自mqtt或者其他地方
            time: Date.now(),
          };
          if (this.dialogFormType === dialogFormType.add) {
            // 添加到列表
            this.customProps.push(propObj);
          } else if (this.dialogFormType === dialogFormType.edit) {
            this.customProps[this.current] = propObj;
          }
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 拷贝绑定数据
    copyDate() {
      if (!this.customProps.length) return;

      this.topo.data.copyDatas = JSON.parse(JSON.stringify(this.customProps));
      this.$message("已复制绑定数据");
    },
    // 粘贴绑定数据
    pasteDate() {
      let copyDatas = JSON.parse(JSON.stringify(this.topo.data.copyDatas));
      copyDatas.forEach((item) => {
        item.time = Date.now();
      });
      this.customProps.push(...copyDatas);
      this.$message("已粘贴绑定数据");
    },
  },
};
</script>
<style lang="scss" scoped>
.data-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .data-label {
    width: 120px;
  }
}
.prop-list-content {
  .bind-data-list {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .bind-btn {
      font-size: 12px;
      margin-left: 30px;
    }
    .el-icon-delete {
      font-size: 14px;
    }
  }
}
.info-content {
  display: flex;
  align-items: center;
  .enter-info {
    width: 250px;
    margin-right: 15px;
  }
}
.menu-group {
  margin-right: 20px;
}
</style>